import { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { buildHomePageStructuredData } from "../data/homePageStructuredData";
import "../App.css";
import ActionButtons from "../components/ActionButtons";
import DeliveryAvailable from "../components/DeliveryAvailable";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Information, { News } from "../components/Information";
import Process from "../components/Process";
import TopMenuPc from "../components/TopMenuPc";
import TopMenuSp from "../components/TopMenuSp";
import Worry from "../components/Worry";
import Reason from "../components/Reason";
import Others from "../components/Others";
import Press from "../components/Press";
import Movie from "../components/Movie";
import Recommendation from "../components/Recommendation";
import TopButton from "../components/TopButton";
import Merit from "../components/Merit";

function Top({ news }: { news: News[] }) {
  const homeJsonLd = useMemo(() => buildHomePageStructuredData(), []);

  return (
    <>
      <Helmet>
        <title>インバウンド対策のための海外配送サービスBeaver Delivery</title>
        <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      </Helmet>
      <div className="App">
        <TopMenuSp />
        <TopMenuPc />
        <Header />
        <Movie />
        <div className="wrap max-w-[1500px] mx-0 md:mx-4 lg:mx-auto px-3">
          <Recommendation />
          <Merit />
          <Process />
          <Reason />
          <DeliveryAvailable />
          <Worry />
          <Others />
          <Press />
          <Information news={news} />
          <ActionButtons />
        </div>
        <Footer />
        <TopButton />
      </div>
    </>
  );
}

export default Top;
